"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateJKFilters = void 0;
var _filters = require("../filters");
var _types = require("../../actions/filters/types");
/**
 * Валидатор фильтров для типа оцениваемой недвижимости "ЖК"
 * Проверяет наличие обязательного поля: Адрес
 * */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const validateJKFilters = () => (dispatch, getState) => {
  const state = getState();
  const {
    filters: {
      address
    }
  } = state;
  if (!address) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.address,
      errorText: 'Укажите адрес или название ЖК'
    }));
    return false;
  }
  return true;
};
exports.validateJKFilters = validateJKFilters;